import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('purchase/getall')
    },

    create (data) {
        return Api().post('purchase/create', data)
    },
    update (data,id) {
        return Api().post('purchase/update/'+id, data)
    },
    getpurchasedata (startdate,enddate) {
        return Api().get('purchase/getpurchasebetweendates/'+startdate+'/'+enddate)
    },

    getallsm () {
        return Api().get('smpurchase/getall')
    },
    createsm (data) {
        return Api().post('smpurchase/create', data)
    },
    updatesm (data,id) {
        return Api().post('smpurchase/update/'+id, data)
    },

    //

    getallgmw () {
        return GmwApi().get('purchase/getall')
    },
    creategmw (data) {
        return GmwApi().post('purchase/create', data)
    },
    updategmw (data,id) {
        return GmwApi().post('purchase/update/'+id, data)
    },
    getpurchasedatagmw (startdate,enddate) {
        return GmwApi().get('purchase/getpurchasebetweendates/'+startdate+'/'+enddate)
    },
}